import React from 'react';
import PageCategory from './PageCategory';
import { makeStyles } from '@mui/styles';

type Props = {
  categories: { [key: string]: any }[];
  color: string;
  closeMenu: () => void;
  categoryType: string;
  hasIcon: boolean;
  name?: string;
};

const useStyles = makeStyles(() => ({
  groupCategory: (props: any) => ({
    listStyle: 'none',
    alignSelf: 'center',
    justifySelf: 'center',
    width: '100%',
    paddingLeft: 0,
    display: 'grid',
    gridTemplateRows: '1fr 1fr 1fr',
    gridAutoFlow: 'column',
    gridColumnGap: '5%',
    justifyContent: 'space-evenly',
    gridArea: 'main',
    gap: props.isMultiColumn && '10px'
  })
}));

const CategoryMenuGroup = ({ categories, color, closeMenu, categoryType, hasIcon }: Props) => {
  const isMultiColumn = categories.length > 1;
  const isCursiveCategory = categoryType === 'cursive';
  const classes = useStyles({ isMultiColumn });
  return (
    <ul className={classes.groupCategory}>
      {categories.map((category: any, i) =>
        category.characters ? (
          <PageCategory
            showBottomBorder={(i + 1) % 3 !== 0}
            key={`${category.category} - ${i}`}
            title={category.category}
            color={color}
            characters={category.characters}
            closeMenu={closeMenu}
            multiColumn={isMultiColumn}
            isCursive={isCursiveCategory}
            hasIcon={hasIcon}
          />
        ) : null
      )}
    </ul>
  );
};

export default CategoryMenuGroup;
